<template>
  <div>
    <div class="login-container">
      <div class="login-container-content">
        <v-card class="mx-auto" outlined>
          <v-form class="login-controls" v-model="valid" autocomplete="off">
            <v-col flex class="sm-12">
              <v-container>
                <v-row class="pa-2">
                  <span class="headline font-weight-bold mx-auto">{{
                    siteText.ui.tokenLoginTitle
                  }}</span>
                </v-row>
                <v-row class="pa-2">
                  <v-text-field
                    class="controlled-font"
                    type="password"
                    :placeholder="siteText.ui.tokenLoginInputText"
                    v-model="UniqueId"
                    required
                    maxlength="8"
                    :rules="[isValidUniqueId]"
                    autocomplete="ignore"
                  ></v-text-field>
                </v-row>
                <v-row v-if="errorMessage">
                  <p class="red--text controlled-font">
                    {{ errorMessage }}
                  </p>
                </v-row>
                <v-row class="pa-2 mt-10">
                  <v-btn
                    id="btn-login"
                    class="mx-auto white--text controlled-font"
                    color="primary"
                    @click="login()"
                    :disabled="!valid"
                  >
                    <v-icon>mdi-login</v-icon>
                    <span class="pl-2">{{ siteText.ui.login }}</span></v-btn
                  >
                </v-row>
              </v-container>
            </v-col>
          </v-form>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
export default {
  components: {},
  mounted() {
    this.UniqueId = this.uniqueId;
  },
  methods: {
    ...mapActions(["getExamineeFromUniqueId", "remoteLogin", "getSettings"]),
    async login() {
      const examineeInfo = await this.getExamineeFromUniqueId(this.UniqueId);
      let errorMessage = "";
      if (!examineeInfo) {
        errorMessage = this.siteText.ui.tokenLoginInvalidToken;
      } else if (examineeInfo.tokenExpired) {
        errorMessage = this.siteText.ui.tokenLoginExpiredToken;
      } else if (examineeInfo.hasTestsAssigned === false) {
        errorMessage = this.siteText.ui.tokenLoginNoAssignedTests;
      }

      if (!errorMessage) {
        console.log(examineeInfo);
        await this.getSettings();
        this.remoteLogin(examineeInfo);
      } else {
        this.setErrorMessage(errorMessage);
      }
    },
    isValidUniqueId(value) {
      if (!value) {
        return this.siteText.ui.tokenLoginTokenRequired;
      } else if (value.length > 8 || value.length < 6) {
        return this.siteText.ui.tokenLoginInvalidToken;
      } else if (!/^([^-\s][a-zA-Z 0-9]{1,8})$/.test(value)) {
        return this.siteText.ui.tokenLoginInvalidToken;
      }
      return true;
    },
    setErrorMessage(errorMessage) {
      this.errorMessage = errorMessage;
      setTimeout(function() {
        this.errorMessage = "";
        document.location.reload();
      }, 5000);
    },
  },
  data: () => ({
    UniqueId: "",
    valid: false,
    errorMessage: "",
  }),
  computed: {
    ...mapGetters(["siteText", "uniqueId"]),
  },
  watch: {
    uniqueId(newValue) {
      this.UniqueId = newValue;
    },
  },
};
</script>

<style scoped>
.login-container {
  transform-origin: center center;
  /*width: 800px;*/
  max-height: 90%;
}

.login-container-content {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  padding: 0 10px 0 10px !important;
}
</style>
